import Fetcher from "Scripts/common/fetcher";

export default class CorporateCharityList {
	constructor() {
		this.list = new Fetcher({
			element:  "#js-charities-fetcher",
		});
	}
}